module.exports = __webpack_public_path__ + "images/emoji/trident.392af801208205435201.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trident.png
// module id = BbBr
// module chunks = 1